export enum FontStyleEnum {
  Classic = 'Classic',
  Modern = 'Modern'
}
export enum ColourStyleEnum {
  Purple = 'Purple',
  Blue = 'Blue',
  Green = 'Green'
}
export interface AddSessionRequest {
  name: string;
  allowUserNavigation: boolean;
  allowViewAllPages: boolean;
  isTour: boolean;
  defaultLanguageCode?: string | null;
  teamReference: string | null;
  fontStyleEnum?: FontStyleEnum | null;
  colourStyleEnum?: ColourStyleEnum | null;
}
export interface PartialUpdateSessionRequest {
  name?: string | null;
  allowUserNavigation?: boolean | null;
  allowViewAllPages?: boolean | null;
  isTour?: boolean | null;
  defaultLanguageCode?: string | null;
  teamReference?: string | null;
  fontStyleEnum?: FontStyleEnum | null;
  colourStyleEnum?: ColourStyleEnum | null;
}
export interface AddSessionPageRequest {
  name: string;
  pageReference?: string | null;
}
export interface UpdateSessionPageRequest {
  name: string;
}
export interface InfoResponse {
  email: string | null;
  isEmailConfirmed: boolean;
}

export interface LoginModel {
  email?: string | null;
  password?: string | null;
}

export interface LoginResponse {
  requiresTwoFactor?: boolean | null;
  alreadyLoggedIn?: boolean | null;
}

export interface RegisterModel {
  email?: string | null;
  password?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  confirmPassword?: string | null;
}

export interface RegisterRequest {
  email: string | null;
  password: string | null;
}

export interface UpdateUserDetailsRequest {
  firstName?: string | null;
  lastName?: string | null;
}
export interface SessionCollection {
  sessions: SessionDetails[];
}
export interface SessionDetails {
  name?: string;
  reference: string;
  createdDateUtc: string;
  publicLink: string;
  allowUserNavigation: boolean;
  allowViewAllPages: boolean;
  isTour: boolean;
  defaultLanguageCode: string | null;
  accessCode: string | null;
  teamReference: string | null;
  teamName: string | null;
  isOwner: boolean;
  fontStyleEnum: FontStyleEnum | null;
  colourStyleEnum: ColourStyleEnum | null;
  defaultShowing: ShowingDetails | null;
}
export interface ShowingCollectionResponse {
  showings: ShowingDetails[];
}
export interface ShowingDetails {
  reference: string;
  startDateUtc: string;
  endDateUtc: string;
  location: string | null;
  isPreview: boolean;
  isDefault: boolean;
  previewLink: string | null;
  publicLink: string | null;
  latestSessionPage: SessionPageDetails | null;
  latestSessionPageBlank: boolean;
  presentationStartUtc: string | null;
}
export interface AddShowingRequest {
  startDateUtc: string;
  endDateUtc?: string | null;
  location: string | null;
}
export interface SessionPageCollection {
  pages: SessionPageDetails[];
}
export interface SessionPageDetails {
  name?: string;
  viewUrl?: string;
  fullViewUrl?: string;
  pageName?: string;
  reference: string;
  createdDateUtc: string;
  pageReference: string | null;
  pageBody?: string | null;
}
export interface PageCollection {
  pages: PageDetails[];
}
export interface PageDetails {
  title?: string;
  body?: string;
  reference: string;
}
export interface AddPageRequest {
  title?: string | null;
  body?: string | null;
}

export interface PageContentResponse {
  rows?: PageContentRowResponse[];
}
export interface PageContentRowResponse {
  reference: string;
  order: number;
  isExpandable: boolean;
  blocks: PageContentBlockResponse[];
}
export interface PageContentBlockResponse {
  reference: string;
  order: number;
  blockType: BlockTypeEnum;
  text: string | null;
  altText: string | null;
  fileName: string | null;
  blobName: string | null;
  textStyle: TextStyleEnum | null;
}
export enum BlockTypeEnum {
  Unknown = 'Unknown',
  Text = 'Text',
  Image = 'Image'
}
export enum TextStyleEnum {
  Unknown = 'Unknown',
  Basic = 'Basic',
  Header = 'Header',
  SubHeader = 'SubHeader'
}
export interface AddPageContentRequest {
  rows: AddPageContentRowRequest[];
}
export interface AddPageContentRowRequest {
  id: string;
  order: number;
  isExpandable: boolean;
  blocks: AddPageContentBlockRequest[];
}
export interface AddPageContentBlockRequest {
  id: string;
  blockType: BlockTypeEnum;
  order: number;
  text: string | null;
  altText: string | null;
  imageName: string | null;
  imageContents: string | null;
  getFromServer: boolean;
  textStyle: TextStyleEnum | null;
}
export interface LanguageCollection {
  languages: LanguageDetails[];
}
export interface LanguageDetails {
  code: string;
  countryCode: string;
  englishName: string;
  nativeName: string;
  displayName: string;
}
export interface ImportDetails {
  createdPageReference: string;
}

export interface UserInfoModel {
  emailAddress: string | null;
  firstName: string | null;
  lastName: string | null;
  roles: string[] | null;
  isSSO: boolean | null;
  accountLevel: string | null;
  features: string[] | null;
}
export interface SessionPagePartialModel {
  reference: string;
  orderIndex?: number | null;
}

export interface SharedKeyResponse {
  sharedKey: string;
  authenticatorUri: string;
}

export interface EnableAuthenticationRequest {
  code: string;
}

export interface DisableAuthenticationRequest {
  code: string;
  useRecoveryCode: boolean;
}

export interface EnableAuthenticationResponse {
  recoveryCodes: string[] | null;
}

export interface MFAResponse {
  isEnabled: boolean;
  isTwoFactorClientRemembered: boolean;
}

export interface CsrfToken {
  value: string | null;
}

export interface EventDetailsResponse {
  events: EventDetailResponse[];
}
export interface EventDetailResponse {
  name: string;
  reference: string;
  startDateUtc: string | null;
  lengthMinutes: number | null;
  totalPages: number;
  totalShowings: number;
  tourName: string | null;
  location: string | null;
  isPast: boolean | null;
  sessionDetails: SessionDetails;
  showingReference: string | null;
  defaultShowingReference: string | null;
  hasMultipleCustomShowings: boolean;
}

export interface TourDetailsResponse {
  tours: TourDetailResponse[];
}
export interface TourDetailResponse {
  name: string;
  reference: string;
  earliestStartDateUtc: string;
  latestEndDateUtc: string | null;
  totalEvents: number | null;
  events: TourEventDetailResponse[];
  teamReference: string | null;
  teamName: string | null;
}

export interface TourEventDetailResponse {
  name: string;
  reference: string;
  startDateUtc: string;
}

export interface TeamsResponse {
  teams: TeamResponse[];
}

export interface TeamResponse {
  name: string;
  totalMembers: number;
  reference: string;
  createdDateUtc: string;
  isOwner: boolean;
}

export interface AddTeamRequest {
  name: string;
}

export interface TeamMembersResponse {
  members: TeamMemberResponse[];
}

export interface TeamMemberResponse {
  reference: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  createdDateUtc: string;
  isConfirmed: boolean;
  isSelf: boolean;
}

export interface AddTeamMemberRequest {
  emailAddress: string;
}

export interface InvitedTeamsResponse {
  teams: InvitedTeamResponse[];
}

export interface InvitedTeamResponse {
  reference: string;
  name: string;
  inviteDateUtc: string;
  confirmedDateUtc: string | null;
  isConfirmed: boolean;
}

export interface ShowingConnectionsResponse {
  data: TimeSeriesData[];
}

export interface TimeSeriesData {
  intervalTime: string;
  numberOfConnections: number;
}

export interface BackgroundResponse {
  hasBackground: boolean;
  backgroundBlobName: string | null;
  backgroundFileName: string | null;
  backgroundType: BackgroundTypeEnum;
}

export interface SetBackgroundRequest {
  fileName: string | null;
  fileContents: string | null;
  backgroundType: BackgroundTypeEnum;
  useOriginalFile: boolean;
}

export enum BackgroundTypeEnum {
  Unknown = 'Unknown',
  None = 'None',
  Image = 'Image',
  Video = 'Video'
}

export interface SetIconRequest {
  fileName: string;
  fileContents: string;
}

export interface IconResponse {
  fileName: string | null;
  blobName: string | null;
  hasIcon: boolean;
}

export interface SessionWelcomeDetails {
  icon: IconResponse;
  hasImage: boolean;
  useNoIcon: boolean;
  blobName: string | null;
  fileName: string | null;
  previewLink: string;
}

export interface SetImage {
  fileName?: string | null;
  fileContents?: string | null;
  removeImage: boolean;
}

export interface SetSessionWelcomeRequest {
  image?: SetImage | null;
  icon?: SetImage | null;
  useNoIcon?: boolean | null;
}

export interface SessionWelcomePageDetails {
  pageId: string;
}

export interface SessionEndDetails {
  donationPageLink: string | null;
  hasDonationPageLink: boolean;
  feedbackLink: string | null;
  hasFeedbackLink: boolean;
  subscribeLink: string | null;
  hasSubscribeLink: boolean;
  previewLink: string;
  pages: SessionEndPageDetails[];
}

export interface SetSessionEndRequest {
  donationPageLink: string | null;
  feedbackLink: string | null;
  subscribeLink: string | null;
}

export interface SessionEndPageDetails {
  endPageReference: string;
  pageId: string;
  name: string;
}

export interface CreateCheckoutSessionResponse {
  clientSecret: string;
}

export interface CheckoutSessionStatusResponse {
  status: string;
  customerEmail: string;
}

export interface CurrentStatusResponse {
  accountLevel: string;
  accountLevelChangeDateUtc?: string;
  pendingAccountLevelEnum?: string;
  pendingAccountLevelDateUtc?: string;
  nextPaymentDateUtc?: string;
  subscriptionCancelAtUtc?: string;
}
